import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Heading,
  Text,
  Link,
  List,
  ListItem,
  Icon,
  Divider,
  Flex,
  Image
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import assets from './assets';
import siteConfig from './siteConfig';

const MarketingFooter = () => {
  return (
    <Box bg="gray.100" color="gray.700" py={14}>
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={10} mb={10}>
          <Box>
            <Image src={assets.teliviLogo} alt="Telivi" h={{ base: '56px', md: '64px' }} mb={6} />
            <Text color="gray.600" mb={6}>
              Telivi delivers isolated business platforms with dedicated infrastructure, databases,
              and tenant-specific domains for every customer.
            </Text>
            <Flex gap={4}>
              <Icon as={FaFacebook} boxSize={5} />
              <Icon as={FaTwitter} boxSize={5} />
              <Icon as={FaInstagram} boxSize={5} />
            </Flex>
          </Box>

          <Box>
            <Heading as="h3" fontSize="lg" mb={4}>
              Platforms
            </Heading>
            <List spacing={3} color="gray.600">
              <ListItem>
                <Link as={RouterLink} to="/platforms#property" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Property Management
                </Link>
              </ListItem>
              <ListItem>
                <Link as={RouterLink} to="/platforms#case" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Case / Legal Management
                </Link>
              </ListItem>
              <ListItem>
                <Link as={RouterLink} to="/platforms#contract" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Contract Management
                </Link>
              </ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h3" fontSize="lg" mb={4}>
              Resources
            </Heading>
            <List spacing={3} color="gray.600">
              <ListItem>
                <Link as={RouterLink} to="/pricing" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Pricing
                </Link>
              </ListItem>
              <ListItem>
                <Link as={RouterLink} to="/how-it-works" color="gray.600" _hover={{ color: 'gray.800' }}>
                  How It Works
                </Link>
              </ListItem>
              <ListItem>
                <Link as={RouterLink} to="/security" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Security & Isolation
                </Link>
              </ListItem>
              <ListItem>
                <Link as={RouterLink} to="/payments-disclosure" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Payments Disclosure
                </Link>
              </ListItem>
              <ListItem>
                <Link as={RouterLink} to="/contact" color="gray.600" _hover={{ color: 'gray.800' }}>
                  Contact
                </Link>
              </ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h3" fontSize="lg" mb={4}>
              Contact
            </Heading>
            <List spacing={3} color="gray.600">
              <ListItem>
                <Flex gap={3} align="flex-start">
                  <Icon as={FaMapMarkerAlt} mt={1} />
                  <Text>{siteConfig.contactAddress}</Text>
                </Flex>
              </ListItem>
              <ListItem>
                <Flex gap={3} align="center">
                  <Icon as={FaPhone} />
                  <Text>{siteConfig.footerPhone}</Text>
                </Flex>
              </ListItem>
              <ListItem>
                <Flex gap={3} align="center">
                  <Icon as={FaEnvelope} />
                  <Text>{siteConfig.supportEmail}</Text>
                </Flex>
              </ListItem>
            </List>
          </Box>
        </SimpleGrid>

        <Divider borderColor="gray.300" mb={6} />

        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          color="gray.500"
          fontSize="sm"
          gap={4}
        >
          <Text>TELIVI IT LLC &copy; 2026. All Rights Reserved.</Text>
          <Link as={RouterLink} to="/login" color="gray.600" _hover={{ color: 'gray.800' }}>
            Login
          </Link>
        </Flex>
      </Container>
    </Box>
  );
};

export default MarketingFooter;
